<template>
  <div id="app">
    <div class="body">
      <router-view class="router a-top" name="a"></router-view>
      <router-view class="router b-wechat" name="b"></router-view>
      <router-view class="router c-game" name="c"></router-view>
      <router-view class="router d-down" name="d"></router-view>
      <router-view class="router" name="e"></router-view>
      <router-view class="router" name="f"></router-view>
      <router-view class="router" name="g"></router-view>
      <router-view class="router" name="h"></router-view>
    </div>
    <router-view name="footer" class="footer-footer"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style scoped>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */

#app,
.body {
  height: 100%;
  /* margin-bottom: -69px; */
  overflow-x: hidden;
  background:#fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue